/**
 * Download Grid
 *
 * @author Rasmus Seindal <rseindal@vertic.com>
 */

import Hammer from 'hammerjs';
import ServerView from '../../framework/server-side-view';

const View = ServerView.extend({
	el: '.download-grid',

	state: {},

	events: {
		'click .download-grid__carousel__controls__range-slider': 'onRangeSliderClick',
		'click .download-grid__carousel__controls__arrows button': 'onArrowBtnClick',
	},

	initialize() {
		window.addEventListener('resize', this.onResize.bind(this));
	},

	onRender() {
		this.hammerRangeSlider = new Hammer(this.el.querySelector('.download-grid__carousel__controls__range-slider'));
		this.hammerRangeSlider.get('pan').set({
			direction: Hammer.DIRECTION_HORIZONTAL,
		});

		this.hammerRangeSlider.on('panleft', this.onRangeSliderPan.bind(this));
		this.hammerRangeSlider.on('panright', this.onRangeSliderPan.bind(this));

		this.hammer = new Hammer(this.el.querySelector('.download-grid__carousel__hammerjs'), {
			inputClass: Hammer.TouchInput,
		});

		this.hammer.get('pan').set({
			direction: Hammer.DIRECTION_HORIZONTAL,
		});

		this.hammer.on('panleft', this.onCarouselPan.bind(this));
		this.hammer.on('panright', this.onCarouselPan.bind(this));
		this.hammer.on('panend', this.onCarouselPan.bind(this));

		this.setState();
		this.configureRangeSlider();

		this.state.carousel.style.transform = 'translateX(0px)';

		//if it doesn't have enough slides, center slides
		if(this.state.center) this.centerSlides(); 
	},

	setState() {
		this.state = {
			carousel: this.el.querySelector('.download-grid__carousel__slides'),
			slidesCount: this.el.querySelectorAll('.download-grid__carousel__slides__slide').length,
			rangeSlider: this.el.querySelector('.download-grid__carousel__controls__range-slider'),
			slidesToMove: 1,
			currentIndex: 1,
			canSwipe: true,
			breakpoints: {
				phone: {
					greater: false,
					slidesInFocus: 1,
					slideWidth: 75, // in %
					controlsMargin: 10, // in px
					width: 767,
				},
				tablet: {
					greater: true,
					slidesInFocus: 2,
					slideWidth: 45, // in %
					controlsMargin: 0, // in px
					width: 768,
				},
				desktop: {
					greater: true,
					slidesInFocus: 3,
					slideWidth: 100 / 3, // in %
					controlsMargin: 0,
					width: 992,
				},
				largeDesktop: {
					greater: true,
					slidesInFocus: 4,
					slideWidth: 100 / 4, // in %
					controlsMargin: 0,
					width: 1440,
				},
			},
			lastSlideInBreakpoint: null,
			deviceWidth: window.innerWidth,
			center: false
		};
	},

	needToCenter(breakpoint){
		if (this.state.slidesCount <= this.state.breakpoints[breakpoint].slidesInFocus) {
			this.el.querySelector('.download-grid__carousel__controls').style.display = 'none';
			this.el.querySelector('.download-grid__carousel').style.paddingBottom = '65px';
			this.state.center = true;
		} else {
			this.state.rangeSlider.dataset.max = this.state.slidesCount - (this.state.breakpoints[breakpoint].slidesInFocus - this.state.slidesToMove);
			this.el.querySelector('.download-grid__carousel__controls').style.display = '';
			this.el.querySelector('.download-grid__carousel').style.paddingBottom = '';
			this.state.center = false;
		}
	},

	centerSlides(){
		const slidesWidth = (this.el.querySelector('.download-grid__carousel__slides__slide').offsetWidth + 30) * this.state.slidesCount;
		var sliderWidth = this.el.querySelector('.download-grid__carousel__hammerjs').offsetWidth;
		var diff = sliderWidth - slidesWidth;
		var x = diff >= 0 ? diff/2 : 0;
		this.state.carousel.style.transform = "translateX(" + x + "px)";
	},

	configureRangeSlider() {
		if (this.state.deviceWidth >= this.state.breakpoints.largeDesktop.width) {
			this.needToCenter("largeDesktop");
		}
		else if (this.state.deviceWidth >= this.state.breakpoints.desktop.width) {
			this.needToCenter("desktop");
		} else if (this.state.deviceWidth >= this.state.breakpoints.tablet.width) {
			this.needToCenter("tablet");
		} else if (this.state.deviceWidth <= this.state.breakpoints.phone.width) {
			this.state.rangeSlider.dataset.max = this.state.slidesCount;
			this.state.center = false;
		}
		this.setRangeSliderThumbWidth();
	},

	getLastSlide() {
		if (this.state.deviceWidth >= this.state.breakpoints.largeDesktop.width) {
			this.state.lastSlideInBreakpoint = (this.state.slidesCount - this.state.breakpoints.largeDesktop.slidesInFocus) + this.state.slidesToMove;
		} else if (this.state.deviceWidth >= this.state.breakpoints.desktop.width) {
			this.state.lastSlideInBreakpoint = (this.state.slidesCount - this.state.breakpoints.desktop.slidesInFocus) + this.state.slidesToMove;
		} else if (this.state.deviceWidth >= this.state.breakpoints.tablet.width) {
			this.state.lastSlideInBreakpoint = (this.state.slidesCount - this.state.breakpoints.tablet.slidesInFocus) + this.state.slidesToMove;
		} else if (this.state.deviceWidth <= this.state.breakpoints.phone.width) {
			this.state.lastSlideInBreakpoint = this.state.slidesCount;
		}
	},

	setIndexAndSlide() {
		this.getLastSlide();
		const slideToIndex = this.state.rangeSlider.dataset.value;
		this.state.currentIndex = parseInt(slideToIndex, 10);

		const lastSlideInBreakPoint = this.state.lastSlideInBreakpoint;
		if (lastSlideInBreakPoint !== this.state.currentIndex) { // not last slide
			const pos = (this.state.currentIndex * 100) - 100;
			this.state.carousel.style.transform = `translateX(-${pos}%)`;
		} else { // last slide
			const carouselWidth = document.querySelector('.download-grid__carousel__hammerjs').offsetWidth;
			const slideWidth = document.querySelector('.download-grid__carousel__slides__slide').offsetWidth;
			const remainingOffset = carouselWidth - slideWidth; // calculate remaining offset for last slide to snap right
			const slidesWidth = document.querySelector('.download-grid__carousel__slides').offsetWidth;

			let pos;

			if (this.state.deviceWidth >= this.state.breakpoints.largeDesktop.width) {
				pos = `${-((this.state.currentIndex * slidesWidth) - slidesWidth)}`;
			} else if (this.state.deviceWidth >= this.state.breakpoints.desktop.width) {
				pos = `${-((this.state.currentIndex * slidesWidth) - slidesWidth)}`;
			} else if (this.state.deviceWidth >= this.state.breakpoints.tablet.width) {
				pos = `${-((this.state.currentIndex * slidesWidth) - slidesWidth)}`;
			} else if (this.state.deviceWidth <= this.state.breakpoints.phone.width) {
				pos = `${(-((this.state.currentIndex * slidesWidth) - slidesWidth) + remainingOffset) - this.state.breakpoints.phone.controlsMargin}`;
			}
			this.state.carousel.style.transform = `translateX(${pos}px)`;
		}
	},

	setRangeSliderThumbWidth() {
		const rangeSlider = this.el.querySelector('.download-grid__carousel__controls__range-slider');
		const rangeSliderThumb = rangeSlider.querySelector('.download-grid__carousel__controls__range-slider__thumb');
		rangeSliderThumb.style.width = `${rangeSlider.offsetWidth / rangeSlider.dataset.max}px`;
	},
	onRangeSliderClick(e) {
		e.stopPropagation();

		const newEventObj = {
			center: {
				x: e.pageX,
			},
		};

		this.onRangeSliderPan(newEventObj);
	},
	onRangeSliderPan(e) {
		const rangeSliderWidth = this.state.rangeSlider.offsetWidth;
		const rangeSliderThumb = this.state.rangeSlider.querySelector('.download-grid__carousel__controls__range-slider__thumb');
		const rangeSliderThumbWidth = rangeSliderThumb.offsetWidth;
		const currentThumbPos = e.center.x - this.state.rangeSlider.offsetLeft;

		if (currentThumbPos >= 0 && currentThumbPos <= (rangeSliderWidth - rangeSliderThumbWidth)) {
			const step = Math.round(rangeSliderWidth / Math.abs(currentThumbPos - rangeSliderWidth));
			this.setRangeSliderValue(step);
		} else if (currentThumbPos < 0) {
			this.setRangeSliderValue(this.state.rangeSlider.dataset.min);
		} else if (currentThumbPos >= (rangeSliderWidth - rangeSliderThumbWidth)) {
			this.setRangeSliderValue(this.state.rangeSlider.dataset.max);
		}
	},
	setRangeSliderValue(value) {
		this.state.rangeSlider.dataset.value = value;
		this.onRangeSliderValueChange();
		this.setIndexAndSlide();
	},
	rangeSliderStepUp() {
		if (this.state.rangeSlider.dataset.value < this.state.rangeSlider.dataset.max) {
			const newValue = parseInt(this.state.rangeSlider.dataset.value) + 1;
			this.setRangeSliderValue(newValue);
		}
	},
	rangeSliderStepDown() {
		if (this.state.rangeSlider.dataset.value > this.state.rangeSlider.dataset.min) {
			const newValue = parseInt(this.state.rangeSlider.dataset.value) - 1;
			this.setRangeSliderValue(newValue);
		}
	},

	onRangeSliderValueChange() {
		const rangeSlider = this.el.querySelector('.download-grid__carousel__controls__range-slider');
		const rangeSliderThumb = rangeSlider.querySelector('.download-grid__carousel__controls__range-slider__thumb');
		rangeSliderThumb.style.left = `${(100 / rangeSlider.dataset.max) * (rangeSlider.dataset.value - 1)}%`;
	},

	rangeSliderIncrement() {
		if (this.state.rangeSlider.dataset.value < this.state.slidesCount) {
			this.rangeSliderStepUp();
		}
	},

	rangeSliderDecrement() {
		if (this.state.rangeSlider.dataset.value > 1) {
			this.rangeSliderStepDown();
		}
	},

	onArrowBtnClick(e) {
		const direction = e.delegateTarget.dataset.controlsDirection;
		if (direction === 'prev') {
			this.rangeSliderDecrement();
		}
		if (direction === 'next') {
			this.rangeSliderIncrement();
		}
		this.setIndexAndSlide();
	},

	onCarouselPan(e) {
		if (e.distance > 50 && this.state.canSwipe) {
			this.state.canSwipe = false;

			if (e.type === 'panleft') {
				this.rangeSliderIncrement();
			}

			if (e.type === 'panright') {
				this.rangeSliderDecrement();
			}

			this.setIndexAndSlide();
		}

		if (e.type === 'panend') {
			this.state.canSwipe = true;
		}
	},

	onResize() {
		// reset slider state
		this.state.rangeSlider.dataset.value = 1;
		this.setState();
		this.configureRangeSlider();
		this.setRangeSliderValue(this.state.rangeSlider.dataset.value);
		if(this.state.center) this.centerSlides(); 
	},
});

export default View;
